import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gaming-servers',
  templateUrl: './gaming-servers.component.html',
  styleUrls: ['./gaming-servers.component.scss']
})
export class GamingServersComponent implements OnInit {
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'gaming-servers'; 
  title: string = 'Consulta Nuestros Precios Sin Compromiso, Contáctanos.'; 

  constructor() { }

  ngOnInit(): void {
  }

}
